import React from "react";
import { Stack, Column, Columns } from "@origin-digital/ods-core";
import { Field, useFormikContext } from "formik";
import FormikSelectField from "../FormComponents/FormikSelectField";
import {
  allAustralianStates,
  poBoxTypes,
} from "../FormComponents/AddressConstants";
import { EICFormData } from "./types";
import { shouldHidePoBoxNumber } from "./helper";
import { GeneralTextFieldWithAutoCompleteOn } from "../FormComponents/GeneralTextFieldWithAutoCompleteOn";

const POBoxFields: React.FC = () => {
  const { values } = useFormikContext<EICFormData>();

  // Check if PO Box number should be hidden
  const hidePoBoxNumber = shouldHidePoBoxNumber(values.poBoxType);

  return (
    <Columns collapseBelow="xl">
      <Column width="5/6">
        {/* PO Box fields */}
        <Stack space={["xlarge", "xlarge"]}>
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                name="poBoxType"
                label="Box type"
                component={FormikSelectField}
                options={poBoxTypes}
              />
            </Column>

            <Column>
              {hidePoBoxNumber ? null : (
                <Field
                  component={GeneralTextFieldWithAutoCompleteOn}
                  name="poBoxNo"
                  label="PO Box no."
                />
              )}
            </Column>
          </Columns>
          <Field
            component={GeneralTextFieldWithAutoCompleteOn}
            name="poBoxSuburb"
            label="Suburb"
          />
          <Columns
            collapseBelow="md"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column>
              <Field
                name="poBoxState"
                label="State"
                component={FormikSelectField}
                options={allAustralianStates}
              />
            </Column>
            <Column>
              <Field
                component={GeneralTextFieldWithAutoCompleteOn}
                name="poBoxPostcode"
                label="Postcode"
              />
            </Column>
          </Columns>
        </Stack>
        {/* End PO Box fields */}
      </Column>
    </Columns>
  );
};

export default POBoxFields;
